module.exports = __webpack_public_path__ + "img/createAdmin6.1344dc76.svg";